import { useDispatch, useSelector, useStore } from "react-redux";
import TaxPayer from "../models/tax-payer";
import {
  setTaxPayerPermissions,
  setTaxPayerPermissionsLoading,
} from "../redux/tax-payer-permissions/tax-payer-permissions-slice";
import { getList } from "../api/generics";
import { SUCCESS } from "../utils/constants/tags";
import { useEffect } from "react";
import { RootState } from "../store";

interface PermissionsProviderProps {
  children: React.ReactNode;
}

const PermissionsProvider: React.FunctionComponent<PermissionsProviderProps> = (
  props,
) => {
  const taxPayer = useSelector(
    (state: RootState) => state.taxPayer.data.taxPayer,
  );

  const dispatch = useDispatch();
  const store = useStore<RootState>();
  const loadTaxPayerPermissions = async (
    taxPayer: TaxPayer,
    isCurrent: () => boolean,
  ) => {
    // A suspended company refuses these requests; the app shows the
    // suspension screen instead.
    if (taxPayer.id === undefined || taxPayer.accessBlocked) {
      return;
    }
    dispatch(setTaxPayerPermissionsLoading(true));

    try {
      const res = await getList<string>(
        `/tax_payer_permissions/${taxPayer.id}/`,
        0,
        0,
      );
      if (!isCurrent()) return;
      dispatch(
        setTaxPayerPermissions(
          res.status === SUCCESS && res.data ? res.data.items : [],
        ),
      );
    } catch {
      if (isCurrent()) dispatch(setTaxPayerPermissions([]));
    } finally {
      if (isCurrent()) dispatch(setTaxPayerPermissionsLoading(false));
    }
  };

  useEffect(
    () => {
      let current = true;
      loadTaxPayerPermissions(
        taxPayer,
        () =>
          current && store.getState().taxPayer.data.taxPayer.id === taxPayer.id,
      );
      return () => {
        current = false;
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [taxPayer],
  );

  return <>{props.children}</>;
};

export default PermissionsProvider;
